module.exports = "<div class=\"accordion\" [ngClass]=\"'accordion--' + variant\">\n  <ng-content></ng-content>\n</div>\n"